import { iframeResizer } from 'iframe-resizer';
import { useEffect, useRef } from "react";
import { PaymentOptionEnum, useGetWSPayPaymentDetails } from "src/common";
import config from "src/config";
import { AppRoutes } from "src/pages/app";

export interface WsPayIframeProps {
  offerId: string;
  paymentOption: PaymentOptionEnum;
  paymentType: string;
  installments?: boolean;
}

export const WsPayIframe = ({ offerId, paymentOption, paymentType, installments = false }: WsPayIframeProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const hasSubmitted = useRef(false);
  const { data, loading, error, refetch } = useGetWSPayPaymentDetails(paymentType);
  const uniqueId = `wsPay-iframe-${paymentOption}${installments ? '-installments' : '-onetime'}`;

  useEffect(() => {
    refetch({
      id: offerId,
      paymentType,
      installments: installments ? 12 : 1,
    });
  }, [offerId, paymentType]);

  const hiddenFields = data ? {
    ...data,
    ReturnURL: `${config.REACT_APP_URL}${AppRoutes.CHECKOUT.CHECKOUT_SUCCESS}`,
    CancelURL: `${config.REACT_APP_URL}${AppRoutes.WEBSHOP.OFFER}/${offerId}`,
    ReturnErrorURL: `${config.REACT_APP_URL}${AppRoutes.CHECKOUT.CHECKOUT_FAILURE}`,
    PaymentPlan: installments ? undefined : '0000',
    __typename: undefined,
  } : null;

  useEffect(() => {
    if (data && formRef.current && !hasSubmitted.current) {
      hasSubmitted.current = true;
      formRef.current.submit();
      iframeResizer({ checkOrigin: false }, `#${uniqueId}`);
    }
  }, [hiddenFields, uniqueId]);

  useEffect(() => {
    hasSubmitted.current = false;
  }, [offerId, paymentType]);

  if (loading || !hiddenFields) return null;
  if (error) return null;

  const renderHiddenFields = (fields: { [key: string]: string | undefined | null }) => Object.keys(fields).map((key) => {
    if (fields[key] === undefined || fields[key] === null) return null;
    return <input key={key} type="hidden" name={key} value={fields[key]!} />
  });

  return (
    <div>
      <form ref={formRef} name="pay" action={config.REACT_APP_WSPAY_URL} method="POST" target={uniqueId}>
        {renderHiddenFields(hiddenFields)}
      </form>
      <iframe
        name={uniqueId}
        id={uniqueId}
        style={{ width: '100%', minHeight: '420px', border: 'none' }}
      ></iframe>
    </div>
  );
};
